import { GzDashboardSaveAsDialogContentWebComponent } from './component/GzDashboardSaveAsDialogContentWebComponent';

export { GzDashboardSaveAsDialogContentWebComponent };
